import { render, staticRenderFns } from "./PatientSendEmail.vue?vue&type=template&id=3c4a60ce&scoped=true&lang=pug&"
import script from "./PatientSendEmail.vue?vue&type=script&lang=js&"
export * from "./PatientSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./PatientSendEmail.vue?vue&type=style&index=0&id=3c4a60ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a60ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCol,VContainer,VDivider,VRow,VTextField})
